import React from 'react';
import ThumbMiddleContent from '@wix/da-ds/pkg/thumbs/legos/ThumbMiddleContent';
import ThumbStatusIndicator from '@wix/da-ds/pkg/thumbs/ThumbStatusIndicator';
import { usePrimaryTier } from '../../../../../../Tier/PrimaryTierContext';
import { Trans } from 'react-i18next';
import { formatPrice } from '../../../../../TierProductCardDumb/utils';
import { useSubscribeButton } from '../../../../../../Button/SubscribeButton/useSubscribeButton';
import HoverOnly from '@wix/da-ds/pkg/thumbs/OverlayHelpers/HoverOnly';
var NeedsSubscriptionMiddleContent = function (_a) {
    var _b;
    var deviation = _a.deviation, thumbHeight = _a.thumbHeight, thumbWidth = _a.thumbWidth, className = _a.className;
    var tier = usePrimaryTier(deviation);
    var _c = useSubscribeButton(tier), onClick = _c.onClick, href = _c.href, biData = _c.biData, text = _c.text;
    if (!tier) {
        return null;
    }
    var canShowDescription = thumbWidth && thumbWidth > 250
        ? thumbHeight && thumbHeight > 200
        : thumbHeight && thumbHeight > 230;
    var canShowCTA = thumbWidth && thumbWidth > 250
        ? thumbHeight && thumbHeight > 150
        : thumbHeight && thumbHeight > 200;
    var isUnreasonablySmall = thumbHeight && thumbHeight < 150;
    if (isUnreasonablySmall) {
        return (React.createElement(HoverOnly, { reverseHidden: true },
            React.createElement(ThumbMiddleContent, { icon: React.createElement(ThumbStatusIndicator, { type: "in-tier", size: "large" }), className: className })));
    }
    return (React.createElement(ThumbMiddleContent, { icon: React.createElement(ThumbStatusIndicator, { type: "in-tier", size: "large" }), subtitle: canShowDescription ? (
        /* prettier-ignore */
        React.createElement(Trans, { i18nKey: "deviationview.overlay.subscriber.perMonth" },
            React.createElement("span", null, { dollarPrice: formatPrice((_b = tier.tier) === null || _b === void 0 ? void 0 : _b.dollarPrice) }),
            "/month")) : undefined, buttonHref: href, buttonTitle: canShowCTA ? text : undefined, onButtonClick: onClick, biData: biData, className: className }));
};
NeedsSubscriptionMiddleContent.displayName = 'NeedsSubscriptionMiddleContent';
export default NeedsSubscriptionMiddleContent;
//# sourceMappingURL=NeedsSubscriptionMiddleContent.js.map